/**
 * Normalizacion de numeros de telefono uruguayos a formato E.164 (+598...).
 *
 * IMPORTANTE: mantener PARIDAD con functions/utils/phoneE164.js. Ambas
 * versiones deben aceptar las mismas entradas y devolver el mismo output.
 * Si cambia una, cambia la otra (y el test src/utils/phoneE164.test.js debe
 * seguir pasando).
 *
 * Convencion Uruguay:
 *   - Movil: 8 digitos comenzando con 9 (ej: "99366768"). Con 0 inicial
 *     comun en formularios: 9 digitos "099366768".
 *   - Fijo: 8 digitos comenzando con 2-4 (Montevideo / interior).
 *
 * Casos soportados:
 *   "099366768"     -> "+59899366768"   (movil con 0 inicial, 9 digitos)
 *   "99366768"      -> "+59899366768"   (movil sin 0 inicial, 8 digitos)
 *   "+59899366768"  -> "+59899366768"   (ya E.164)
 *   "59899366768"   -> "+59899366768"   (E.164 sin +)
 *   "598 99 366768" -> "+59899366768"   (E.164 con espacios o guiones)
 *   "21234567"      -> "+59821234567"   (fijo Montevideo, 8 digitos)
 *   ""              -> ""
 *   null/undefined  -> ""
 *   "abc"           -> ""               (sin digitos validos)
 */
export const normalizePhoneUY = (raw) => {
  if (!raw || typeof raw !== "string") return "";
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 0) return "";

  // Ya tiene codigo de pais 598 al frente -> agregar +
  if (digits.startsWith("598")) return `+${digits}`;

  // Movil con 0 inicial (9 digitos: "099XXXXXX") -> sacar el 0
  if (digits.startsWith("09") && digits.length === 9) {
    return `+598${digits.slice(1)}`;
  }

  // 8 digitos sin codigo de pais (movil "99XXXXXX" o fijo "2XXXXXXX")
  if (digits.length === 8) {
    return `+598${digits}`;
  }

  // Fallback: asumir Uruguay y prefijar +598. Cubre entradas raras pero
  // numericas; si la entrada es invalida deberia haberse devuelto "" antes.
  return `+598${digits}`;
};

/**
 * Devuelve solo los digitos para usar en URLs wa.me (sin el "+").
 * Ej: "+59899366768" -> "59899366768"
 */
export const toWaMeDigits = (e164) => String(e164 || "").replace(/\D/g, "");
